import { z } from 'zod';
import { AccountIdSchema } from './accounts';
import { UserIdSchema } from './users';
import { TeamIdSchema } from './teams';
import { TrackableInfoSchema, TrackableSchema } from './trackables';
export var GameIdSchema = z.string();
export var GameSettingsSchema = z.object({
    account_id: AccountIdSchema,
    id: z.coerce.string().pipe(GameIdSchema),
    name: z.string().optional(),
    // Additional properties used in legacy code during TS migration
    // These match the shape expected by GamesUtils.timeRemainingStringFromGame
    member_type: z.union([z.string(), z.number()]).optional(),
    start_date: z.string(),
    end_date: z.string(),
    start_hour: z.union([z.string(), z.number()]),
    start_minute: z.union([z.string(), z.number()]),
    end_hour: z.union([z.string(), z.number()]),
    end_minute: z.union([z.string(), z.number()]),
    timezone: z.string().optional(),
    frequency: z.union([z.string(), z.number()]).optional(),
    game_type: z.union([z.string(), z.number()]).optional(),
    is_managed_game: z.boolean().optional()
});
export var GameAccountSchema = z.object({
    account_id: AccountIdSchema,
    name: z.string(),
    games_account_status: z.coerce.number().optional()
});
var statusesSchema = z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5)
]);
export var GameStatusSchema = z.coerce.number()
    .pipe(statusesSchema);
export var GameSchema = z.object({
    settings: GameSettingsSchema,
    accounts: z.array(GameAccountSchema).or(z.undefined()),
    users: z.array(UserIdSchema).optional(),
    teams: z.array(TeamIdSchema).optional(),
    trackables: z.array(TrackableSchema),
    // Additional properties used in legacy code during TS migration
    members: z.array(z.unknown()).optional()
});
/**
 * This is going to be used during the transition to TS.  Basically I need a "loose" schema that
 * will let through extra properties that we do not know about yet, but I need the "Game" type to be
 * based on the "pure" schema.  That way TS will raise errors if we try to use a property that is
 * not yet defined but the actual data will still keep it.
 */
export var LooseGameSchema = GameSchema.merge(z.object({
    settings: GameSettingsSchema.passthrough(),
    accounts: z.array(GameAccountSchema.passthrough()).or(z.undefined()),
    trackables: z.array(TrackableSchema.merge(z.object({
        info: z.array(TrackableInfoSchema.passthrough())
    })).passthrough())
})).passthrough();
